import React, { useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { isMobile } from 'app/middleware/hooks';
// import { AutoComplete } from 'antd';
import {
  SearchOutlined,
  EyeInvisibleOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import {
  SEARCH_BAR_ALL,
  SEARCH_BAR_MEMBER,
  SEARCH_BAR_PLACES,
  SEARCH_BAR_BIKER_BED,
  SEARCH_BAR_BIKE_CLUB,
  SEARCH_BAR_TOUR,
  SEARCH_BAR_HISTORY,
} from '../../../constants/mainSearch.constants';

import {
  BikerBedIconSearch,
  MemberSearchIcon,
  BikerClubIconSearch,
  ToursIconSearch,
  PlacesSearchIcon,
} from '../MainMenu/svg';

// const { Option, OptGroup } = AutoComplete;

const listScopes = [
  SEARCH_BAR_PLACES,
  SEARCH_BAR_BIKER_BED,
  SEARCH_BAR_BIKE_CLUB,
  SEARCH_BAR_MEMBER,
  SEARCH_BAR_TOUR,
  SEARCH_BAR_ALL,
];

const CODE_ESCAPE = 27;

export const prepareSize = (isTourTab) => {
  const isShort = isMobile(1320);
  const isSmalest = isMobile(450);

  const getOffset = () => {
    if (isShort) {
      return isTourTab ? [0, 99] : [0, 52];
    }
    // return (isTourTab) ? [0, 127] : [0, 67];
    return isTourTab ? [0, 113] : [0, 63];
  };

  // const width = isShort ? (isSmalest ? '100%' : 260) : 460;
  const width = isShort ? '100%' : 460;
  const mainIcon = isShort
    ? { width: '20px', height: '20px' }
    : { width: '24px', height: '24px' };
  const tourIcon = isShort
    ? { width: '23px', height: '20px' }
    : { width: '24px', height: '24px' };
  const offset = getOffset();

  return {
    width,
    mainIcon,
    tourIcon,
    offset,
    isSmalest,
  };
};

const CorespondingIcon = ({ scope, ...props }) => {
  switch (scope) {
    case SEARCH_BAR_TOUR:
      return <ToursIconSearch {...props} />;

    case SEARCH_BAR_BIKE_CLUB:
      return <BikerClubIconSearch {...props} />;

    case SEARCH_BAR_BIKER_BED:
      return <BikerBedIconSearch {...props} />;

    case SEARCH_BAR_PLACES:
      return <PlacesSearchIcon {...props} />;

    case SEARCH_BAR_MEMBER:
      return <MemberSearchIcon {...props} />;

    default:
      return <SearchOutlined {...props} />;
  }
};

const getItems = (data, scope) => (scope && data && data[scope]) || [];

const getKey = (el, marker = '') =>
  el.data && el.data.id
    ? `${el.data.id}${marker}`
    : `${el.data.lat}_${el.data.lng}_${el.value}_${marker}`;

const prepareItems = (data, scope) => {
  let items = data
    .filter((el) => el && el.data)
    .map((el) => {
      el.type = scope;
      const dataList = {
        value: getKey(el, getItems(data, scope).marker),
        label: (
          <div className="list_item" el={el}>
            {el.isLoading ? (
              <LoadingOutlined
                width="14px"
                height="14px"
                className="main-search-item-icon"
              />
            ) : (
              <CorespondingIcon
                scope={scope}
                width="14px"
                height="14px"
                className="main-search-item-icon"
              />
            )}
            <div className="main-search-item-text">
              {el.value || el.data.name}
            </div>
          </div>
        ),
      };

      return dataList;
    });

  if (data.length === 1 && !data[0].data && items.length === 0) {
    items = [
      {
        value: 'no found',
        label: (
          <div className="list_item">
            <EyeInvisibleOutlined className="main-search-item-icon" />
            <div className="main-search-item-text">
              <FormattedMessage
                id="No results found in the chosen category"
                defaultMessage="No results found in the chosen category"
              />
            </div>
          </div>
        ),
      },
    ];
  }

  return items;
};

const relatedItems = (data, scope, dependItemLength) => {
  const dataItems = [];

  listScopes
    .filter((kind) => kind !== scope)
    .forEach((type) => {
      getItems(data, type)
        .filter((el) => el && el.data)
        .slice(0, dependItemLength)
        .forEach((el) => {
          el.type = type;
          if (el.data !== 555) {
            dataItems.push({
              value: getKey(el, getItems(data, scope).marker),
              label: (
                <div className="list_item" el={el}>
                  <CorespondingIcon
                    scope={type}
                    width="14px"
                    height="14px"
                    className="main-search-item-icon"
                  />
                  <div className="main-search-item-text">
                    {el.value || el.data.name}
                  </div>
                </div>
              ),
            });
          }
        });
    });

  return dataItems;
};

export const prepareData = (data, scope, seatchText, dependItemLength) => {
  const isHistoryList = !!data[SEARCH_BAR_HISTORY];

  const list = prepareItems(getItems(data, scope), scope);
  const relatedList = relatedItems(data, scope, dependItemLength);

  const dataList = [];

  if (isHistoryList) {
    relatedList.unshift(list);
    if (relatedList.length > 0) {
      dataList.push({
        label: seatchText.recentSearches,
        options: relatedList,
      });
    }
  } else if (relatedList.length > 0) {
    dataList.push({
      label: seatchText.recentSearches,
      options: list,
    });

    dataList.push({
      label: seatchText.relatedSearch,
      options: relatedList,
    });
  }

  return dataList;
};

export const useEscListener = (deFocus) => {
  const isExistEscListener = useRef(null);
  const handleEsc = (e) => e.keyCode === CODE_ESCAPE && deFocus();

  const setListener = () => {
    if (!isExistEscListener.current) {
      document.addEventListener('keydown', handleEsc, false);
      isExistEscListener.current = true;
    }
  };
  const clearListener = () => {
    document.removeEventListener('keydown', handleEsc, false);
    isExistEscListener.current = false;
  };
  return [setListener, clearListener];
};

export const getRoadTypes = (bit) => {
  let res = '';
  if (+bit === +31) res = '0';

  for (let i = 1; i <= 31; i++) {
    if (i && bit) {
      if (res !== '') res += ',';
      res += i;
    }
  }
  if (bit === 0) res = '99';
  return res;
};
